import type { FaireProductEntity } from "../../entity_types/product";

export const p_sddafsbt2n: FaireProductEntity = {
  token: "p_sddafsbt2n",
  type: "product",
  name: "Macadamia Nut Honey Coconut Peanut Butter",
  brandName: "North Shore Goodies",
  imageUrl:
    "https://cdn.faire.com/fastly/8d58b7c997ae83c11e021815bd338a03cc9ce42244876125cb06ae3888f04ca0.jpeg",
  priceDollars: 3.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/6d13c9cf15c17e50d42d298e20b8f6075adfa57e779e5c15440152a7dd3ea920.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
